var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "loading-wrapper" } },
    [
      _c(
        "v-main",
        { staticClass: "page" },
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [_c("transition", [_c("LoginPage")], 1)],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }